import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { PatientAddress } from 'src/app/core/models/patient/patientAddress';


@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss']
})
export class AddressComponent implements OnInit {
  /* Input the state of Edit */

  @Input() address: PatientAddress;
  addressFields: FormGroup;

  constructor() { }

  ngOnInit() {
  }

}
